export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/caigouhetongyufukuanbaoxian-39eb1748ada81d436c093cccc5c923dc.png";